var API_QUERIES_DELETE = "/api/v1/queries/{id}";
var API_QUERIES_GETLIST = "/api/v1/queries/{type}";

define("components/util/apiendpoints", function(){});

